export type PayrollDeductionType = 'BackgroundCheck';

export type PayrollDeductionStatus = 'Pending' | 'Processed';

export interface PayrollDeduction {
  id: string;
  type: PayrollDeductionType;
  description: string;
  amount: number;
  date: string;
  status: PayrollDeductionStatus;
}
